export { default, detached } from './SalesboardCard';
